import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import LoadingProgress from '../components/LoadingProgress'

import { fetchWithdrawals } from '../actions/withdrawals'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import WithdrawalEntryList from '../components/WithdrawalEntryList'

import WithdrawalFilterForm from '../forms/WithdrawalFilterForm'

import "../styles/WithdrawalsAdminView.css"

class WithdrawalView extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const now = new Date()
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substring(0, 10)
    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substring(0, 10)
    this.props.fetchWithdrawals('', '', firstDayOfMonth, lastDayOfMonth)
  }

  renderWithdrawals() {
    const { withdrawals, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!withdrawals || loading) {
      return <LoadingProgress />
    }

    return (<WithdrawalEntryList withdrawals={withdrawals} />)
  }

  renderBankWithdrawals() {
    const { withdrawals, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!withdrawals || loading) {
      return <LoadingProgress />
    }

    let withdrawalInBank = 0
    let withdrawalOutBank = 0

    withdrawals.forEach(withdrawal => {

      if (withdrawal.Bank && withdrawal.Balanced) {

        switch (withdrawal.Type) {
          case 0: {
            withdrawalInBank = withdrawalInBank + (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2)
            break
          }
          case 1: {
            withdrawalInBank = withdrawalInBank + (withdrawal.Units5BillCashReal * 5) + (withdrawal.Units10BillCashReal * 10) + (withdrawal.Units20BillCashReal * 20) + (withdrawal.Units50BillCashReal * 50)
            break
          }
          case 2: {
            withdrawalInBank = withdrawalInBank + (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2)
            break
          }
        }

      } else if (!withdrawal.Bank && withdrawal.Balanced) {
        switch (withdrawal.Type) {
          case 0: {
            withdrawalOutBank = withdrawalInBank + (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2)
            break
          }
          case 1: {
            withdrawalOutBank = withdrawalInBank + (withdrawal.Units5BillCashReal * 5) + (withdrawal.Units10BillCashReal * 10) + (withdrawal.Units20BillCashReal * 20) + (withdrawal.Units50BillCashReal * 50)
            break
          }
          case 2: {
            withdrawalOutBank = withdrawalInBank + (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2)
            break
          }
        }
      }

    });

    return { withdrawalInBank, withdrawalOutBank }
  }

  renderBalanceWithdrawals() {
    const { withdrawals, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!withdrawals || loading) {
      return <LoadingProgress />
    }

    let withdrawalTotalBalance = 0

    withdrawals.forEach(withdrawal => {

      if (withdrawal.Balanced) {

        withdrawalTotalBalance = withdrawalTotalBalance + withdrawal.Balance

      }

    });

    return withdrawalTotalBalance
  }

  render() {

    const { role, withdrawals } = this.props

    return (
      <div className="withdrawals-admin-view">

        {/* Header */}
        <div className="withdrawals-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-money-bill-wave mr-3"></i>
                <span className="text-vw-dark mr-1">Retiros de</span>
                <span className="text-vw-light">Efectivo</span>
              </h1>
            </div>
          </div>
        </div>

        {/* Filter */}
        <div className="withdrawals-admin-filter-card">
          <div className="withdrawals-admin-filter-header">
            <h3>
              <i className="fas fa-filter"></i>
              <span>Filtro</span>
            </h3>
          </div>
          <div className="withdrawals-admin-filter-body">
            <WithdrawalFilterForm />
          </div>
        </div>

        {role === 'ADMIN' && withdrawals && (() => {
          let withdrawalInBank = 0
          let withdrawalOutBank = 0
          let withdrawalTotalBalance = 0

          withdrawals.forEach(withdrawal => {
            if (withdrawal.Bank && withdrawal.Balanced) {
              switch (withdrawal.Type) {
                case 0: withdrawalInBank += (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2); break
                case 1: withdrawalInBank += (withdrawal.Units5BillCashReal * 5) + (withdrawal.Units10BillCashReal * 10) + (withdrawal.Units20BillCashReal * 20) + (withdrawal.Units50BillCashReal * 50); break
                case 2: withdrawalInBank += (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2); break
              }
            } else if (!withdrawal.Bank && withdrawal.Balanced) {
              switch (withdrawal.Type) {
                case 0: withdrawalOutBank += (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2); break
                case 1: withdrawalOutBank += (withdrawal.Units5BillCashReal * 5) + (withdrawal.Units10BillCashReal * 10) + (withdrawal.Units20BillCashReal * 20) + (withdrawal.Units50BillCashReal * 50); break
                case 2: withdrawalOutBank += (withdrawal.Units050CoinCashReal * 0.50) + withdrawal.Units100CoinCashReal + (withdrawal.Units200CoinCashReal * 2); break
              }
            }
            if (withdrawal.Balanced) withdrawalTotalBalance += withdrawal.Balance
          })

          return (
            <div className="withdrawals-admin-filter-card">
              <div className="withdrawals-admin-filter-header">
                <h3>
                  <i className="fas fa-chart-line"></i>
                  <span>Resumen</span>
                </h3>
              </div>
              <div className="withdrawals-admin-filter-body">
                <div className="withdrawals-summary-cards">
                  <div className="withdrawals-summary-card">
                    <div className="card-icon income">
                      <i className="fas fa-euro-sign"></i>
                    </div>
                    <div className="card-content">
                      <h3>Ingresado</h3>
                      <div className="amount">{withdrawalInBank.toFixed(2)} €</div>
                    </div>
                  </div>
                  <div className="withdrawals-summary-card">
                    <div className="card-icon balance">
                      <i className="fas fa-balance-scale"></i>
                    </div>
                    <div className="card-content">
                      <h3>Pendiente</h3>
                      <div className="amount">{withdrawalOutBank.toFixed(2)} €</div>
                    </div>
                  </div>
                  <div className="withdrawals-summary-card">
                    <div className="card-icon balance">
                      <i className="fas fa-calculator"></i>
                    </div>
                    <div className="card-content">
                      <h3>Balance General</h3>
                      <div className="amount">{withdrawalTotalBalance.toFixed(2)} €</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })()}

        {/* Withdrawals Table */}
        <div className="withdrawals-table-container">
          {this.renderWithdrawals()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  withdrawals: state.withdrawals.withdrawals,
  error: state.withdrawals.error,
  loading: state.withdrawals.loading,
  form: state.form,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  fetchWithdrawals: bindActionCreators(fetchWithdrawals, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawalView)


